<template>
  <div class="workbench-container cfo-cockpit">
    <div class="workbench-body">
      <CfoHeaderCard />
      <div class="workbench">
        <!-- <div class="brief-grid">
          <div class="brief-grid-item">
            <EnterpriseWarRoom :agent-id="agentId" @open-detail="$emit('open-detail', $event)" @open-list="$emit('open-list', $event)" @smart-analysis="$emit('smart-analysis', $event)" @start-chat="$emit('start-chat', $event)" />
          </div>
          <div class="brief-grid-item">
            <TaskQueue :agent-id="agentId" @open-detail="(taskData) => $emit('task-open-detail', taskData)" @open-list="$emit('task-open-list', $event)" />
          </div>
          <div class="brief-grid-item">
            <PendingDecision @open-detail="$emit('decision-open-detail', $event)" @open-list="$emit('decision-open-list', $event)" @smart-analysis="$emit('smart-analysis', $event)" />
          </div>
        </div> -->
        <div class="flex-container gap-10">
        <div class="flex-item-2">
          <EnterpriseWarRoom
            :key="agentId"
            :agent-id="agentId"
            @open-detail="$emit('open-detail', $event)"
            @open-list="$emit('open-list', $event)"
            @smart-analysis="$emit('smart-analysis', $event)"
            @start-chat="$emit('start-chat', $event)"
          />
        </div>
        <div class="flex-item">
          <TaskQueue
            :key="agentId"
            :agent-id="agentId"
            @open-detail="(taskData) => $emit('task-open-detail', taskData)"
            @open-list="$emit('task-open-list', $event)"
          />
        </div>
        <!-- <div class="flex-item">
          <PendingDecision
            @open-detail="$emit('decision-open-detail', $event)"
            @open-list="$emit('decision-open-list', $event)"
            @smart-analysis="$emit('smart-analysis', $event)"
          />
        </div> -->
      </div>
        <CfoCoreIndicators :key="agentId" @smart-analysis="$emit('smart-analysis', $event)" />
        <CfoAnalysisTools @open-tool="$emit('open-tool', $event)" />
        <CfoProfitLossSankey :key="agentId" />
        <CfoMarginEvents :key="agentId" />
        <CfoForecastSimulation :key="agentId" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAgentIdByInternalName } from '@/store/modules/cosmoClaw'
import CfoHeaderCard from './components/CfoHeaderCard.vue'
import EnterpriseWarRoom from '../components/EnterpriseWarRoom.vue'
import TaskQueue from '../components/TaskQueue.vue'
// import PendingDecision from '../components/PendingDecisions.vue'
import CfoCoreIndicators from './components/CfoCoreIndicators.vue'
import CfoAnalysisTools from './components/CfoAnalysisTools.vue'
import CfoProfitLossSankey from './components/CfoProfitLossSankey.vue'
import CfoMarginEvents from './components/CfoMarginEvents.vue'
import CfoForecastSimulation from './components/CfoForecastSimulation.vue'
import { mapState } from 'vuex'

export default {
  name: 'CfoWorkbench',
  components: {
    CfoHeaderCard,
    EnterpriseWarRoom,
    TaskQueue,
    // PendingDecision,
    CfoCoreIndicators,
    CfoAnalysisTools,
    CfoProfitLossSankey,
    CfoMarginEvents,
    CfoForecastSimulation
  },
  computed: {
    ...mapState('user', ['agentList']),
    // 数字人 agentId 优先取 URL query.agentId（同路由多实例切换），无则从 agentList 自动匹配
    agentId() {
      const queryAgentId = (this.$route.query && this.$route.query.agentId) || ''
      if (queryAgentId) {
        const list = Array.isArray(this.agentList) ? this.agentList : []
        const matched = list.find(
          (a) =>
            String(a.id) === String(queryAgentId) ||
            String(a.agentId || '') === String(queryAgentId)
        )
        if (matched) return String(queryAgentId)
      }
      return getAgentIdByInternalName('cai_wu_shu_zi_ren', this.agentList)
    }
  },
  mounted() {
    if (this.agentId) {
      this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_ID', this.agentId)
    }
  },
  watch: {
    agentId(val) {
      if (val) {
        this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_ID', val)
      }
    }
  }
}</script>

<style lang="scss" scoped>
@import './styles/cfo-cockpit.scss';

$CFO_MIN_WIDTH: 1000px;

.workbench-container {
  height: 100%;
  padding: 24px;
  min-height: 0;
  min-width: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.workbench-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.workbench {
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(37, 99, 235, 0.28) transparent;
  padding-bottom: 16px;
}

.workbench::-webkit-scrollbar {
  width: 8px;
}

.workbench::-webkit-scrollbar-track {
  background: transparent;
}

.workbench::-webkit-scrollbar-thumb {
  background: rgba(37, 99, 235, 0.28);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.brief-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  flex-shrink: 0;
}

.brief-grid-item {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;

  ::v-deep .hel-module {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
  }
}
.flex-container {
  width: 100%;
  min-width: 700px;
  display: flex;
}
.flex-item {
  width: calc((100% - 10px) / 3);
  flex-shrink: 1;
  min-width: 0;
}
.flex-item-2 {
  width: calc((100% - 10px) / 3 * 2);
  flex-shrink: 1;
  min-width: 0;
}
.gap-10 {
  gap: 10px;
}
</style>
